export enum OrganizationType {
    Association = 1,
    Tuna = 2,
    Club = 3,
    Party = 4
}
